import React from 'react'
import { Loader } from '../LoadingElements'
import styles from './styles.module.scss'

export default function PageLoaderContainer({ flex = false }) {
  return (
    <section className={`${styles.loader} ${flex ? styles.loader_flex : ''}`}>
      <Loader />
    </section>
  )
}
